export default function () {
  this.loadItem()
}
